import { render, staticRenderFns } from "./DetailListView.vue?vue&type=template&id=411b961b"
import script from "./DetailListView.vue?vue&type=script&lang=js"
export * from "./DetailListView.vue?vue&type=script&lang=js"
import style0 from "./DetailListView.vue?vue&type=style&index=0&id=411b961b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports